import { title } from "process";
import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import styles from './Modal.module.scss'

const Modal = ({ isShowing, hide,title,children, className }) => {
  const { t } = useTranslation();
  return isShowing
    ? ReactDOM.createPortal(
        <>
          <div className={styles.overlay}>
            <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
              <div className={`${styles.modal}${className ? ` ${className}` : ''}`}>
                <div className={styles.header}>
                  <h4>{title}</h4>
               
                  <button
                    type="button"
                    className={`${styles.closeBtn} has-tooltip`}
                    onClick={hide}
                    aria-label={t("common.close")}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className={styles.modalBody}>{children}</div>
              </div>
            </div>
          </div>
        </>,
        document.body
      )
    : null;
};

export default Modal;